module.exports = __webpack_public_path__ + "static/media/centos.78465eab.png";